import * as permissions from '@/common/permissionConstants';
import { useDevOnly } from '@/composables/useDevOnly';
import { useAuthStore } from '@/stores/auth';

export default [
    {
        path: 'lens',
        name: 'lens',
        redirect: { name: 'lens-builder' },
        component: () => import('../views/LensPage.vue'),
        beforeEnter: () => {
            const { isBnSupport } = useDevOnly();
            if (!isBnSupport()) return { name: 'home' };
            const authStore = useAuthStore();
            if (!authStore.hasPermission(permissions.LENS_VIEW)) return { name: 'home' };
        },
        children: [
            {
                path: 'builder/:lensId?',
                name: 'lens-builder',
                meta: { label: 'New lens' },
                component: () => import('../views/lens/LensBuilderPage.vue'),
                props: (route) => ({ lensId: route.params.lensId, ootb: route.query.ootb === '1' }),
            },
            {
                path: 'ootb/:lensId',
                name: 'lens-ootb-view',
                component: () => import('../views/lens/LensViewPage.vue'),
                props: (route) => ({ lensId: route.params.lensId, ootb: true }),
            },
            {
                path: ':lensId',
                name: 'lens-view',
                component: () => import('../views/lens/LensViewPage.vue'),
                props: true,
            },
        ],
    },
];
